var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-input",
        _vm._b(
          {
            attrs: { clearable: "", placeholder: _vm.placeholder },
            scopedSlots: _vm._u([
              {
                key: "prepend",
                fn: function () {
                  return [
                    _c(
                      "el-select",
                      {
                        style: { width: _vm.prependWidth },
                        attrs: { size: "mini" },
                        model: {
                          value: _vm.prependProxy,
                          callback: function ($$v) {
                            _vm.prependProxy = $$v
                          },
                          expression: "prependProxy",
                        },
                      },
                      _vm._l(_vm.options, function (option) {
                        return _c("el-option", {
                          key: option.value,
                          attrs: { label: option.label, value: option.value },
                        })
                      }),
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.inputValProxy,
              callback: function ($$v) {
                _vm.inputValProxy = $$v
              },
              expression: "inputValProxy",
            },
          },
          "el-input",
          _vm.$attrs,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }